module.exports = __webpack_public_path__ + "img/sprite.ea0201ad.svg";